<template>
  <div class="Pon-Popup">
    <div class="Pon-Popup__header" :style="{ backgroundImage: `url('${data.logo}')` }">
      <div class="Pon-Popup__price">
        <span class="Pon-Popup__usd">$ {{ data?.nft_data?.floor_price_usd?.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}</span>
        <span class="Pon-Popup__percent" :class="data?.nft_data?.change_1d_percent < 0 ? 'Pon-Popup__percent--red' : 'Pon-Popup__percent--green'">
          {{ formatPercent(data?.nft_data?.change_1d_percent) }}
        </span>
      </div>
      <div class="Pon-Popup__balance">{{ data?.nft_data?.floor_price_eth?.toFixed(2) }}</div>
    </div>
    <div 
      class="Pon-Popup__privileges"
      :class="isLegendAccount ? 'Pon-Popup__privileges--bg' : ''"
      :style="isLegendAccount ? { backgroundImage: `url('${BG_LEGEND}')` } : {}"
    >
      <div class="Pon-Popup__title">
        <CrownIcon class="Pon-Popup__title-crown" v-if="isLegendAccount"/>
        <StarsIcon v-else/> 
        <template v-if="isLegendAccount">
          Легенда PoN
        </template>
        <template v-else>
          Привилегии PoN
        </template>
      </div>
      <div class="Pon-Popup__list">
  
        <div class="Pon-Popup__item">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <DropIcon class="Pon-Popup__icon--drop" />
            </div>
            Полный доступ к Drops Capital
          </div>
        </div>
        
        <div class="Pon-Popup__item">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <DropIcon class="Pon-Popup__icon--drop" />
            </div>
            Лучшие раунды для комьюнити
          </div>
        </div>
        
        <div class="Pon-Popup__item" v-if="isLegendAccount">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <CrownIcon class="Pon-Popup__icon--crown" />
            </div>
            Боярский подкаст
          </div>
        </div>
        
        <a class="Pon-Popup__item Pon-Popup__item--hover" href="https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxODkyMjYzODQ1" target="_blank">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <img
                :src="require(`@/Groups/Pon/private/media/images/icon-ponchat1.png`)"
                class="Pon-Popup__icon--pon-chat"
                alt="pon"
              />
            </div>
            PoN Holders
          </div>
          <LinkIcon class="Pon-Popup__link-icon" />
        </a>
        
        <a class="Pon-Popup__item Pon-Popup__item--hover" href="https://t.me/+6mrvhmDBdG5jMjc6" target="_blank">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <img
                :src="require(`@/Groups/Pon/private/media/images/icon-ponchat3.png`)"
                class="Pon-Popup__icon--pon-chat"
                alt="pon"
              />
            </div>
            Кэпитал Work
          </div>
          <LinkIcon class="Pon-Popup__link-icon" />
        </a>

        <a class="Pon-Popup__item Pon-Popup__item--hover" href="https://t.me/+CbJGANCaNcJjNGIy" target="_blank">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <img
                :src="require(`@/Groups/Pon/private/media/images/icon-ponchat2.png`)"
                class="Pon-Popup__icon--pon-chat"
                alt="pon"
              />
            </div>
            Кэпитал Meme
          </div>
          <LinkIcon class="Pon-Popup__link-icon" />
        </a>
        
        <a class="Pon-Popup__item Pon-Popup__item--hover" href="https://t.me/+LsimjfsTOgg5YzFi" target="_blank">
          <div class="Pon-Popup__item-box">
            <div class="Pon-Popup__icon">
              <img
                :src="require(`@/Groups/Pon/private/media/images/icon-ponchat4.png`)"
                class="Pon-Popup__icon--pon-chat"
                alt="pon"
              />
            </div>
            Кэпитал Алертс
          </div>
          <LinkIcon class="Pon-Popup__link-icon" />
        </a>
        
        <ButtonGift class="Pon-Popup__gift-btn" @click="openGiftSubscribe()" :type="'start'">Подарить подписку</ButtonGift>
        <template v-if="isLegendAccount">
          <button class="Pon-Popup__legend-continue-btn" @click="openLegendSubscribe()">Продлить Легенду PoN</button>
        </template>
        <ButtonLegend class="Pon-Popup__legend-btn" :type="'start'" @click="openLegendSubscribe()" v-else/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  import { subscribeWidget } from '@/Groups/Pon/private/imports/subscribeWidget';
  
  //--------------------------
  import StarsIcon from '@/Groups/Pon/private/svg/StarsIcon.vue';
  import DropIcon from "@/Groups/Pon/private/svg/DropIcon.vue";
  import CrownIcon from '@/Groups/Pon/private/svg/CrownIcon.vue';
  import LinkIcon from '@shared/UI/SVG/LinkIcon.vue';
  import { ButtonLegend, ButtonGift } from '@/Groups/Pon/private/imports/externalTemplates';
  //--------------------------
  const store = useStore();
  //--------------------------
  const { openLegendSubscribe, openGiftSubscribe } = subscribeWidget();
  //--------------------------
  const BG_LEGEND = require('@/Shared/images/backgrounds/bg_legend_height.png');
  //--------------------------
  const isLegendAccount = computed(() => store.getters['UserSystem/hasLegendAccess']);

  const data = computed(() => store.state.Pon.ponData);

  const formatPercent = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '0%';
    let num = Number(value);
    if (num > 0 && num < 0.01) {
      num = 0.01;
    } else if (num < 0 && num > -0.01) {
      num = -0.01;
    }
    const rounded = Math.abs(num).toFixed(2);
    const sign = num > 0 ? '+' : num < 0 ? '−' : '';
    return `${sign}${rounded}%`;
  };
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
